import styled from 'styled-components';

export const StyledColor = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 2px;
  background: ${({ color }) => {
    return `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`;
  }};
`;

export const StyledSwatch = styled.div`
  margin-left: 12px;
  margin-right: 8px;
  background: #fff;
  height: 16px;
  width: 16px;
  cursor: pointer;
`;

export const StyledInput = styled.input`
  display: inline-block;
  background: #ffffff;
  border: none;
  width: 100%;
  :focus {
    outline: none;
  }
  text-transform: uppercase;
`;

export const ControlWrapper = styled.div`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  border-radius: 5px;
  background: #ffffff;
  height: 40px;
  overflow: auto;
  border: ${props => (props.valid ? '1px solid #DFE3EC' : '1px solid #dc3545')};
`;

export const StyledPopover = styled.div`
  position: absolute;
  z-index: 2;
`;

export const StyledCover = styled.div`
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
`;
